import React, { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Container,
  Button,
  Typography,
  Box,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import { logEventos } from "../../../services/services";
import { getData } from "../../../services/library";
import moment from "moment";
import "moment/locale/es";
import { v4 as uuidv4 } from "uuid";

const SolicitudDePersonalForm = ({
  isEditMode,
  rowInfo,
  handleOpenCloseModalForm,
  obtenerSolicitudes,
  mostrarAlertaTemporal,
}) => {
   const rrhhAdmin = localStorage.getItem("adminrrhh");
  const [fetchSucursales, setFetchSucursales] = useState([]);
  const [fetchPuestos, setFetchPuestos] = useState([]);
  const [fetchPeriodos, setFetchPeriodos] = useState([]);
  const [fetchUsers, setFetchUsers] = useState([]);
//console.log("fetchSucursales",fetchSucursales)
  const [data, setData] = useState({
    id: isEditMode ? rowInfo.id : undefined,
    id_puesto: isEditMode ? rowInfo.id_puesto : "",
    id_sucursal: isEditMode  ? rowInfo.id_sucursal  :  rrhhAdmin === 1 ? null : localStorage.getItem('sucursal'), 
    fecha: isEditMode
      ? moment(rowInfo.fecha).format("YYYY-MM-DD HH:mm:ss")
      : "",
    fecha_solicitud: isEditMode ? rowInfo.fecha_solicitud : "",
    descripcion: isEditMode ? rowInfo.descripcion ?? "" : "",
    prioridad: isEditMode ? rowInfo.prioridad : "",
    para_remplazo: isEditMode ? (rowInfo.para_remplazo === "SI" ? 1 : 0) : 0,
    quien_remplaza: isEditMode ? rowInfo.quien_remplaza : "",
    user: isEditMode
      ? rowInfo.creador_de_la_solicitud
      : localStorage.getItem("user"),
    activa: isEditMode ? rowInfo.activa : 1,
    uuid: isEditMode ? undefined : uuidv4(),
    oculto: isEditMode ? rowInfo.oculto : 0,
  });
//console.log("data",data)
  moment.locale("es-ar");

  useEffect(() => {
    getData(`/solicitudDePersonal/puestos`, setFetchPuestos);
    getData(`/solicitudDePersonal/sucursales`, setFetchSucursales);
    getData(`/solicitudDePersonal/periodos`, setFetchPeriodos);
    getData("/SP_referencias/getUsers/refenenciado", setFetchUsers); // Lo saco de referencias para no crear el mismo endpoint
  }, []);

  const oculto = localStorage.getItem("solicitud_oculta");

  // const rrhhAdmin = localStorage.getItem("adminrrhh");

  const user = localStorage.getItem("user");

  const sucursalesAuth = localStorage.getItem("suc_auth");

  const sucursalesAutorizadas = sucursalesAuth.split(",");

  console.log("sucursalesAutorizadas", sucursalesAutorizadas);

  // const oculto = localStorage.getItem("solicitud_oculta");

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (
      (name === "id_puesto" && data.descripcion === "") ||
      data.descripcion === null
    ) {
      const selectedPuesto = fetchPuestos.find((puesto) => puesto.id === value);
      setData((prevData) => ({
        ...prevData,
        [name]: value,
        descripcion: selectedPuesto
          ? selectedPuesto.descripcion !== null
            ? selectedPuesto.descripcion
            : prevData.descripcion
          : "",
      }));
    } else {
      setData((prevData) => ({
        ...prevData,
        [name]: value,
        ...(name === "para_remplazo" && value === 0
          ? { quien_remplaza: "" }
          : {}),
      }));
    }
  };

  const sucursalesFiltradas = fetchSucursales.filter((sucursal) =>
    sucursalesAutorizadas.includes(String(sucursal.id))
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !data.id_puesto ||
      !data.id_sucursal ||
      data.para_remplazo === null ||
      data.oculto === null ||
      data.descripcion.trim() === "" ||
      !data.prioridad ||
      (data.para_remplazo === 1 &&
        (!data.quien_remplaza || data.quien_remplaza.trim() === ""))
    ) {
      mostrarAlertaTemporal(
        "Por favor, complete todos los campos obligatorios.",
        "error"
      );
      return;
    }

    const solicitud = {
      id_puesto: data.id_puesto,
      id_sucursal: data.id_sucursal,
      prioridad: data.prioridad,
      descripcion: data.descripcion,
      para_remplazo: data.para_remplazo,
      quien_remplaza: data.quien_remplaza,
      autorizado_por: rrhhAdmin === "1" ? user : null,
      user: data.user ?? localStorage.getItem("user"),
      activa: isEditMode ? rowInfo.activa : rrhhAdmin === "1" ? 1 : null,
      ...(isEditMode ? { id: data.id } : { uuid: data.uuid }),
      oculto: data.oculto,
    };

    try {
      const response = await fetch(
        isEditMode
          ? `${UrlApi}/solicitudDePersonal/${rowInfo.id}`
          : `${UrlApi}/solicitudDePersonal`,
        {
          method: isEditMode ? "PUT" : "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(solicitud),
        }
      );

      if (response.ok) {
        mostrarAlertaTemporal(
          isEditMode
            ? "Solicitud actualizada correctamente"
            : "Solicitud creada con éxito",
          "success"
        );
        obtenerSolicitudes();
        handleOpenCloseModalForm();
      } else {
        const error = await response.json();
        mostrarAlertaTemporal(`Error: ${error.message}`, "error");
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      mostrarAlertaTemporal("Hubo un problema con la solicitud.", "error");
    }
  };

  const puestosOrdenados = fetchPuestos.sort((a, b) =>
    a.puesto.localeCompare(b.puesto)
  );

  // const sucursalesOrdenadas = sucursalesFiltradas.sort((a, b) =>
  //   a.nombre.localeCompare(b.nombre)
  // );

  const usuariosOrdenadas = fetchUsers.sort((a, b) =>
    a.nombre.localeCompare(b.nombre)
  );

  return (
    <Dialog open onClose={handleOpenCloseModalForm} maxWidth="lg" fullWidth>
      <Box sx={{ backgroundColor: "#1F618D", marginBottom: 4 }}>
        <DialogTitle>
          <Typography variant="h6" align="center" color="#fff">
            {isEditMode ? "Editar solicitud" : "Nueva solicitud"}
          </Typography>
        </DialogTitle>
      </Box>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Puesto</InputLabel>
              <Select
                name="id_puesto"
                value={data.id_puesto}
                onChange={handleChange}
                label="Puesto"
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      overflow: "auto",
                    },
                  },
                }}
              >
                {puestosOrdenados.map((puesto) => (
                  <MenuItem
                    key={puesto.id}
                    value={puesto.id}
                    onChange={() => {
                      setData((prevData) => ({
                        ...prevData,
                        descripcion: puesto.descripcion,
                      }));
                    }}
                  >
                    {puesto.puesto}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/*
          rhhhadmin ve todas las sucursales sino filtra por usuaio teniendo las sucursal abilitadas nomas
          */}
     {rrhhAdmin === "1" ? (
  <Grid item xs={12}>
    <FormControl fullWidth size="small">
      <InputLabel>Sucursal</InputLabel>
      <Select
        name="id_sucursal"
        value={data.id_sucursal}
        onChange={handleChange}
        label="Sucursal"
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200,
              overflow: "auto",
            },
          },
        }}
      >
        {fetchSucursales.map((sucursal) => (
          <MenuItem key={sucursal.id} value={sucursal.id}>
            {sucursal.id} {sucursal.nombre}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
) : (
  <Grid item xs={12}>
    <FormControl fullWidth size="small">
      <InputLabel>Sucursal</InputLabel>
      <Select
        name="id_sucursal"
        value={data.id_sucursal}
        onChange={handleChange}
        label="Sucursal"
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200,
              overflow: "auto",
            },
          },
        }}
      >
        {sucursalesFiltradas.map((sucursal) => (
          <MenuItem key={sucursal.id} value={sucursal.id}>
            {sucursal.nombre}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)}



         
           
            
       
          <Grid item xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Prioridad</InputLabel>
              <Select
                name="prioridad"
                value={data.prioridad || ""}
                onChange={handleChange}
                label="Prioridad"
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      overflow: "auto",
                    },
                  },
                }}
              >
                {fetchPeriodos.map((periodo) => (
                  <MenuItem key={periodo.id} value={periodo.id}>
                    {periodo.valor}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {rrhhAdmin === "1" && (
            <Grid item xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Solicitado por:</InputLabel>
                <Select
                  name="user"
                  value={data.user}
                  onChange={handleChange}
                  label="Solicitado por"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        overflow: "auto",
                      },
                    },
                  }}
                >
                  {fetchUsers.map((user) => (
                    <MenuItem key={user.id} value={user.username}>
                      {`${user.nombre} ${user.apellido}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>¿Es para remplazo?</InputLabel>
              <Select
                name="para_remplazo"
                value={data.para_remplazo}
                onChange={handleChange}
                label="¿Es para remplazo?"
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      overflow: "auto",
                    },
                  },
                }}
              >
                <MenuItem value={0}>No</MenuItem>
                <MenuItem value={1}>Si</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {data.para_remplazo === 1 && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="¿A quien remplaza?"
                name="quien_remplaza"
                value={data.quien_remplaza}
                onChange={handleChange}
                required
                inputProps={{
                  maxLength: 60,
                }}
              />
              <Typography variant="body2" color="textSecondary">
                {data.quien_remplaza?.length ?? 0} / 60 caracteres
              </Typography>
            </Grid>
          )}

          {oculto === "1" && (
            <Grid item xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Ocultar solicitud</InputLabel>
                <Select
                  name="oculto"
                  value={data.oculto}
                  onChange={handleChange}
                  label="¿Es una solicitud oculta?"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        overflow: "auto",
                      },
                    },
                  }}
                >
                  <MenuItem value={0}>No</MenuItem>
                  <MenuItem value={1}>Si</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Breve descripcion del puesto"
              name="descripcion"
              value={data.descripcion || ""}
              onChange={handleChange}
              required
              multiline
              rows={3}
              inputProps={{
                maxLength: 250, // Limita la longitud del texto a 250 caracteres
              }}
            />
            <Typography variant="body2" color="textSecondary">
              {data.descripcion.length || 0} / 250 caracteres
            </Typography>
          </Grid>

          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button onClick={handleOpenCloseModalForm} color="error">
              Cancelar
            </Button>
            <Button onClick={handleSubmit} color="primary">
              {isEditMode ? "Guardar" : "Agregar"}
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
};

export default SolicitudDePersonalForm;
